<template>
  <div class="select-filter">
    <div class="tabs">
      <div class="tab" :class="{'active': tab == 'general'}" @click="tab = 'general'">
        {{$t('selectFilter.generalCriteria')}}</div>
      <div class="tab" :class="{'active': tab == 'clients'}" @click="tab = 'clients'">
        {{$t('selectFilter.clientCriteria')}}</div>
    </div>
    <div class="tabs-content">
      <div class="tab-content" v-show="tab == 'general'">
        <div class="select-accordion" @click="general.cdGrpLevel1.show = !general.cdGrpLevel1.show">
          <div class="name-filter">{{$t('selectFilter.categoryLevel1')}}</div>
          <div class="icon arrow-down"></div>
        </div>
        <div class="table-pictos"
          v-if="general.cdGrpLevel1 && general.cdGrpLevel1.show && general.cdGrpLevel1.filtersArray && general.cdGrpLevel1.filtersArray.length > 0">

          <div class="row-pictos" v-for="i in Math.ceil(general.cdGrpLevel1.filtersArray.length / 4)">
            <Item v-for="(item ) in general.cdGrpLevel1.filtersArray.slice((i - 1) * 4, i * 4)"
              v-bind:pictoClass="item.picto" v-bind:label="item.name" v-bind:value="item.value"
              v-on:input="item.value = $event" :key="item.key" />
          </div>

          <div class="cdFamily select-container"
            v-show="general.cdGrpLevel1.filtersArray && general.cdGrpLevel1.filtersArray.filter(e => e.value === true).length > 0">
            <v-select placeholder="Marque" v-model="general.cdGrpLevel1.brand"
              :options="general.productBrand.filtersArray" label="name" :closeOnSelect="true" :multiple="false"
              :clearSearchOnSelect="true"></v-select>
          </div>
        </div>

        <div class="select-accordion" @click="general.cdGrpLevel2.show = !general.cdGrpLevel2.show">
          <div class="name-filter">{{$t('selectFilter.categoryLevel2')}}</div>
          <div class="icon arrow-down"></div>
        </div>
        <div class="cdGrpLevel2 select-container"
          v-show="general.cdGrpLevel2 && general.cdGrpLevel2.show && general.cdGrpLevel2.filtersArray && general.cdGrpLevel2.filtersArray.length > 0">
          <v-select v-model="selectedCdGrpLevel2" :options="general.cdGrpLevel2.filtersArray" label="name"
            :closeOnSelect="false" :multiple="true" :clearSearchOnSelect="false" @input="updateSelectedCdGrpLevel2"
            ref='theSelectCdGrpLevel2'></v-select>
          <div class="cdGrpLevel2 select-container"
            v-show="selectedCdGrpLevel2.length > 0 && general.productBrand.filtersArray.length > 0">
            <v-select placeholder="Marque" v-model="general.cdGrpLevel2.brand"
              :options="general.productBrand.filtersArray" label="name" :closeOnSelect="true" :multiple="false"
              :clearSearchOnSelect="true"></v-select>
          </div>
        </div>

        <div class="select-accordion" @click="general.cdFamily.show = !general.cdFamily.show">
          <div class="name-filter">{{$t('selectFilter.family')}}</div>
          <div class="icon arrow-down"></div>
        </div>
        <div class="cdFamily select-container"
          v-show="general.cdFamily && general.cdFamily.show && general.cdFamily.filtersArray && general.cdFamily.filtersArray.length > 0">
          <v-select v-model="selectedFamilies" :options="general.cdFamily.filtersArray" label="name"
            :closeOnSelect="false" :multiple="true" :clearSearchOnSelect="false" @input="updateSelectedFamilies"
            ref='theSelectFamilies'></v-select>
          <div class="cdFamily select-container"
            v-show="selectedFamilies.length > 0 && general.productBrand.filtersArray.length > 0">
            <v-select placeholder="Marque" v-model="general.cdFamily.brand" :options="general.productBrand.filtersArray"
              label="name" :closeOnSelect="true" :multiple="false" :clearSearchOnSelect="true"></v-select>
          </div>
        </div>

        <div class="select-accordion" @click="general.codeFamille.show = !general.codeFamille.show">
          <div class="name-filter">{{$t('selectFilter.codeFamily')}}</div>
          <div class="icon arrow-down"></div>
        </div>
        <div class="code-famille-container" v-show="general.codeFamille.show">
          <div class="select-container">
            <input class="input-design code-famille" placeholder="Code" type="text" v-on:keyup.enter="addFamilyCode"
              v-model="newFamilyCode">
            <button @click="addFamilyCode">{{$t('selectFilter.add')}}</button>
          </div>
          <div v-for="(code, i) in familyCodes" class="familyCode">
            {{code.name}} <button @click="removeFamilyCode(i)">X</button>
          </div>
          <div class="icon arrow-down"></div>
        </div>

        <div class="select-accordion" @click="general.cdProduct.show = !general.cdProduct.show">
          <div class="name-filter">{{$t('selectFilter.codeProduct')}}</div>
          <div class="icon arrow-down"></div>
        </div>
        <div class="code-famille-container" v-show="general.cdProduct.show">
          <div class="select-container">
            <input class="input-design code-famille" placeholder="Code" type="text" v-on:keyup.enter="addProductCode"
              v-model="newProductCode">
            <button @click="addProductCode">{{$t('selectFilter.add')}}</button>
          </div>
          <div v-for="(code, i) in productCodes" class="familyCode">
            {{code.name}} <button @click="removeProductCode(i)">X</button>
          </div>
          <div class="icon arrow-down"></div>
        </div>

        <div class="select-accordion" @click="general.productBrand.show = !general.productBrand.show">
          <div class="name-filter">{{$t('selectFilter.productBrand')}}</div>
          <div class="icon arrow-down"></div>
        </div>
        <div class="cdFamily select-container"
          v-show="general.productBrand && general.productBrand.show && general.productBrand.filtersArray && general.productBrand.filtersArray.length > 0">
          <v-select v-model="selectedBrands" :options="general.productBrand.filtersArray" label="name"
            :closeOnSelect="false" :multiple="true" :clearSearchOnSelect="false" @input="updateSelectedBrands"
            ref='theSelectBrands'></v-select>
        </div>

        <!--div v-if="this.businessUnit.startsWith('NOR')" class="select-accordion" @click="clients.recommendedFamilies.show = !clients.recommendedFamilies.show">
          <div class="name-filter">{{$t('selectFilter.recommendedFamilies')}}</div>
          <div class="icon arrow-down"></div>
        </div>
        <div class="cdFamily select-container" v-show="clients.recommendedFamilies && clients.recommendedFamilies.show && clients.recommendedFamilies.filtersArray && clients.recommendedFamilies.filtersArray.length > 0">
          <v-select :value="selectedRecommendedFamilies" :options="clients.recommendedFamilies.filtersArray" label="name" :closeOnSelect="false" :multiple="true" :clearSearchOnSelect="false" @input="updateSelectedRecommendedFamilies" ref='theSelectRecommendedFamilies'></v-select>
        </div-->


        <div class="add-filter" @click="addFilter">{{$t('selectFilter.addFilter')}}</div>
      </div>
      <div class="tab-content" v-if="tab == 'clients'">

        <div class="select-accordion" @click="clients.constructeur.show = !clients.constructeur.show">
          <div class="name-filter">{{$t('selectFilter.manufacturer')}}</div>
          <div class="icon arrow-down"></div>
        </div>
        <div class="cdFamily select-container"
          v-show="clients.constructeur && clients.constructeur.show && clients.constructeur.filtersArray && clients.constructeur.filtersArray.length > 0">
          <v-select v-model="selectedConstructeurs" :options="clients.constructeur.filtersArray" label="name"
            :closeOnSelect="false" :multiple="true" :clearSearchOnSelect="false" @input="updateSelectedConstructeurs"
            ref='theSelectConstructeur'></v-select>
        </div>

        <div class="select-accordion" @click="clients.shopZone.show = !clients.shopZone.show">
          <div class="name-filter">{{$t('selectFilter.shopZone')}}</div>
          <div class="icon arrow-down"></div>
        </div>
        <div class="cdFamily select-container" v-show="clients.shopZone && clients.shopZone.show">
          <v-select v-model="selectedShopZone" :options="clients.shopZone.filtersArray" label="name"
            :closeOnSelect="false" :multiple="true" :clearSearchOnSelect="false" @input="updateSelectedShopZone"
            ref='theSelectShopZone'></v-select>
        </div>

        <div class="select-accordion" @click="clients.civilite.show = !clients.civilite.show">
          <div class="name-filter">{{$t('selectFilter.civilite')}}</div>
          <div class="icon arrow-down"></div>
        </div>

        <div class="radios" v-if="clients.civilite.show">
          <div class="radio" @click="clients.civilite.filters.homme.value = !clients.civilite.filters.homme.value;">
            <div class="circle" :class="{'active': clients.civilite.filters.homme.value}"></div>
            <div class="radio-name">{{$t('selectFilter.man')}}</div>
          </div>
          <div class="radio" @click="clients.civilite.filters.femme.value = !clients.civilite.filters.femme.value;">
            <div class="circle" :class="{'active': clients.civilite.filters.femme.value}"></div>
            <div class="radio-name">{{$t('selectFilter.woman')}}</div>
          </div>
        </div>
        <div class="radios" v-if="clients.civilite.show">
          <div class="radio" @click="clients.civilite.filters.societe.value = !clients.civilite.filters.societe.value;">
            <div class="circle" :class="{'active': clients.civilite.filters.societe.value}"></div>
            <div class="radio-name">{{$t('selectFilter.company')}}</div>
          </div>
          <div class="radio" @click="clients.civilite.filters.autre.value = !clients.civilite.filters.autre.value;">
            <div class="circle" :class="{'active': clients.civilite.filters.autre.value}"></div>
            <div class="radio-name">{{$t('selectFilter.other')}}</div>
          </div>
        </div>

        <div class="select-accordion" @click="clients.fidelite.show = !clients.fidelite.show">
          <div class="name-filter">{{$t('selectFilter.fidelity')}}</div>
          <div class="icon arrow-down"></div>
        </div>

        <div class="radios" v-if="clients.fidelite.show">
          <div class="radio"
            @click="clients.fidelite.filters.adherent.value = !clients.fidelite.filters.adherent.value; clients.fidelite.filters.nonAdherent.value = !clients.fidelite.filters.adherent.value">
            <div class="circle" :class="{'active': clients.fidelite.filters.adherent.value}"></div>
            <div class="radio-name">{{$t('selectFilter.member')}}</div>
          </div>
          <div class="radio"
            @click="clients.fidelite.filters.nonAdherent.value = !clients.fidelite.filters.nonAdherent.value; clients.fidelite.filters.adherent.value = !clients.fidelite.filters.nonAdherent.value">
            <div class="circle" :class="{'active': clients.fidelite.filters.nonAdherent.value}"></div>
            <div class="radio-name">{{$t('selectFilter.notMember')}}</div>
          </div>
        </div>

        <div class="select-accordion" @click="clients.pass_entretien.show = !clients.pass_entretien.show"
          v-if="businessUnit=='NORFRA'">
          <div class="name-filter">{{$t('selectFilter.pass_entretien')}}</div>
          <div class="icon arrow-down"></div>
        </div>

        <div class="radios" v-if="clients.pass_entretien.show && businessUnit=='NORFRA'">
          <div class="radio"
            @click="clients.pass_entretien.filters.pass_entretien.value = !clients.pass_entretien.filters.pass_entretien.value; clients.pass_entretien.filters.nopass_entretien.value = !clients.pass_entretien.filters.pass_entretien.value">
            <div class="circle" :class="{'active': clients.pass_entretien.filters.pass_entretien.value}"></div>
            <div class="radio-name">{{$t('selectFilter.pass_entretien')}}</div>
          </div>
          <div class="radio"
            @click="clients.pass_entretien.filters.nopass_entretien.value = !clients.pass_entretien.filters.nopass_entretien.value; clients.pass_entretien.filters.pass_entretien.value = !clients.pass_entretien.filters.nopass_entretien.value">
            <div class="circle" :class="{'active': clients.pass_entretien.filters.nopass_entretien.value}"></div>
            <div class="radio-name">{{$t('selectFilter.nopass_entretien')}}</div>
          </div>
        </div>

        <div class="select-accordion" @click="clients.shopType.show = !clients.shopType.show">
          <div class="name-filter">{{$t('selectFilter.shopType')}}</div>
          <div class="icon arrow-down"></div>
        </div>

        <div class="radios" v-if="clients.shopType.show">
          <div class="radio"
            @click="clients.shopType.selectedSuccursale = !clients.shopType.selectedSuccursale; shopTypeClick('succursale')">
            <div class="circle" :class="{'active': clients.shopType.selectedSuccursale}"></div>
            <div class="radio-name">{{$t('selectFilter.succursale')}}</div>
          </div>
          <div class="radio"
            @click="clients.shopType.selectedFranchise = !clients.shopType.selectedFranchise; shopTypeClick('franchise')">
            <div class="circle" :class="{'active': clients.shopType.selectedFranchise}"></div>
            <div class="radio-name">{{$t('selectFilter.franchise')}}</div>
          </div>
        </div>

        <div class="select-accordion" @click="clients.cdShop.show = !clients.cdShop.show">
          <div class="name-filter">{{$t('selectFilter.codeShop')}}</div>
          <div class="icon arrow-down"></div>
        </div>
        <div class="code-famille-container" v-show="clients.cdShop.show">
          <div class="select-container">
            <input class="input-design code-famille" placeholder="Code" type="text" v-on:keyup.enter="addShopCode"
              v-model="newShopCode">
            <button @click="addShopCode">{{$t('selectFilter.add')}}</button>
          </div>
          <div v-for="(code, i) in shopCodes" class="familyCode">
            {{code.name}} <button @click="removeShopCode(i)">X</button>
          </div>
          <div class="icon arrow-down"></div>
        </div>

        <div class="select-accordion" @click="clients.visite.show = !clients.visite.show">
          <div class="name-filter">{{$t('selectFilter.firstVisitDate')}}</div>
          <div class="icon arrow-down"></div>
        </div>
        <div class="visite-container" v-if="clients.visite.show">
          <div class="select-container">
            <v-select :options="options" v-model="clients.visite.filters.valueVisite.operator"></v-select>
          </div>
          <!-- input placeholder="yyyy-mm-dd" class="input-design" type="text" v-model="clients.visite.filters.valueVisite.value" -->
          <input class="input-design" type="text" v-model="clients.visite.filters.valueVisite.value"
            placeholder="yyyy-mm-dd" required pattern="^\d{4}-\d{2}-\d{2}$">
        </div>

        <div class="select-accordion" @click="clients.age.show = !clients.age.show">
          <div class="name-filter">{{$t('selectFilter.age')}}</div>
          <div class="icon arrow-down"></div>
        </div>
        <div class="visite-container" v-if="clients.age.show">
          <div class="select-container">
            <v-select :options="options" v-model="clients.age.filters.valueAge.operator"></v-select>
          </div>
          <input class="input-design" type="text" v-model="clients.age.filters.valueAge.value" placeholder="age"
            required pattern="^([1-9][0-9]{0,2}|1000)$"> <!-- accept an age from 1 to 1000 -->
        </div>

        <div class="select-accordion" @click="clients.contactabilite.show = !clients.contactabilite.show">
          <div class="name-filter">{{$t('selectFilter.contactabilite')}}</div>
          <div class="icon arrow-down"></div>
        </div>
        <div class="cdFamily select-container"
          v-show="clients.contactabilite && clients.contactabilite.show && clients.contactabilite.filtersArray && clients.contactabilite.filtersArray.length > 0">
          <v-select :value="selectedContactabilite" :options="clients.contactabilite.filtersArray" label="name"
            :closeOnSelect="false" :multiple="true" :clearSearchOnSelect="false" @input="updateSelectedContactabilite"
            ref='theSelectContactabilite'></v-select>
        </div>

        <div class="select-accordion" @click="clients.rfm2425.show = !clients.rfm2425.show">
          <div class="name-filter">{{ $t('selectFilter.segment2425') }}</div>
          <div class="icon arrow-down"></div>
        </div>
        <div class="cdFamily select-container"
          v-show="clients.rfm2425 && clients.rfm2425.show && clients.rfm22425.filtersArray && clients.rfm2425.filtersArray.length > 0">
          <v-select v-model="selectedRfm2425" :options="clients.rfm2425.filtersArray" label="name"
            :closeOnSelect="false" :multiple="true" :clearSearchOnSelect="false" @input="updateSelectedRfm2425"
            ref='theSelectRfm2425'></v-select>
        </div>

        <div class="select-accordion" @click="clients.rfm2324.show = !clients.rfm2324.show">
          <div class="name-filter">{{ $t('selectFilter.segment2324') }}</div>
          <div class="icon arrow-down"></div>
        </div>
        <div class="cdFamily select-container"
          v-show="clients.rfm2324 && clients.rfm2324.show && clients.rfm2324.filtersArray && clients.rfm2324.filtersArray.length > 0">
          <v-select v-model="selectedRfm2324" :options="clients.rfm2324.filtersArray" label="name"
            :closeOnSelect="false" :multiple="true" :clearSearchOnSelect="false" @input="updateSelectedRfm2324"
            ref='theSelectRfm2324'></v-select>
        </div>

        <div class="select-accordion" @click="clients.rfm2223.show = !clients.rfm2223.show">
          <div class="name-filter">{{$t('selectFilter.segment2223')}}</div>
          <div class="icon arrow-down"></div>
        </div>
        <div class="cdFamily select-container"
          v-show="clients.rfm2223 && clients.rfm2223.show && clients.rfm2223.filtersArray &&clients.rfm2223.filtersArray.length > 0">
          <v-select v-model="selectedRfm2223" :options="clients.rfm2223.filtersArray" label="name"
            :closeOnSelect="false" :multiple="true" :clearSearchOnSelect="false" @input="updateSelectedRfm2223"
            ref='theSelectRfm2223'></v-select>
        </div>

        <div class="select-accordion" @click="clients.rfm2122.show = !clients.rfm2122.show">
          <div class="name-filter">{{$t('selectFilter.segment2122')}}</div>
          <div class="icon arrow-down"></div>
        </div>
        <div class="cdFamily select-container"
          v-show="clients.rfm2122 && clients.rfm2122.show && clients.rfm2122.filtersArray &&clients.rfm2122.filtersArray.length > 0">
          <v-select v-model="selectedRfm2122" :options="clients.rfm2122.filtersArray" label="name"
            :closeOnSelect="false" :multiple="true" :clearSearchOnSelect="false" @input="updateSelectedRfm2122"
            ref='theSelectRfm2122'></v-select>
        </div>

        <div class="select-accordion" @click="clients.rfm2021.show = !clients.rfm2021.show">
          <div class="name-filter">{{$t('selectFilter.segment2021')}}</div>
          <div class="icon arrow-down"></div>
        </div>
        <div class="cdFamily select-container"
          v-show="clients.rfm2021 && clients.rfm2021.show && clients.rfm2021.filtersArray &&clients.rfm2021.filtersArray.length > 0">
          <v-select v-model="selectedRfm2021" :options="clients.rfm2021.filtersArray" label="name"
            :closeOnSelect="false" :multiple="true" :clearSearchOnSelect="false" @input="updateSelectedRfm2021"
            ref='theSelectRfm2021'></v-select>
        </div>

        <div class="select-accordion" @click="clients.rfm1920.show = !clients.rfm1920.show">
          <div class="name-filter">{{$t('selectFilter.segment1920')}}</div>
          <div class="icon arrow-down"></div>
        </div>
        <div class="cdFamily select-container"
          v-show="clients.rfm1920 && clients.rfm1920.show && clients.rfm1920.filtersArray &&clients.rfm1920.filtersArray.length > 0">
          <v-select v-model="selectedRfm1920" :options="clients.rfm1920.filtersArray" label="name"
            :closeOnSelect="false" :multiple="true" :clearSearchOnSelect="false" @input="updateSelectedRfm1920"
            ref='theSelectRfm1920'></v-select>
        </div>

        <div class="select-accordion" @click="clients.rfm1819.show = !clients.rfm1819.show">
          <div class="name-filter">{{$t('selectFilter.segment1819')}}</div>
          <div class="icon arrow-down"></div>
        </div>
        <div class="cdFamily select-container"
          v-show="clients.rfm1819 && clients.rfm1819.show && clients.rfm1819.filtersArray &&clients.rfm1819.filtersArray.length > 0">
          <v-select v-model="selectedRfm1819" :options="clients.rfm1819.filtersArray" label="name"
            :closeOnSelect="false" :multiple="true" :clearSearchOnSelect="false" @input="updateSelectedRfm1819"
            ref='theSelectRfm1819'></v-select>
        </div>

        <div class="select-accordion" @click="clients.rfm1718.show = !clients.rfm1718.show">
          <div class="name-filter">{{$t('selectFilter.segment1718')}}</div>
          <div class="icon arrow-down"></div>
        </div>
        <div class="cdFamily select-container"
          v-show="clients.rfm1718 && clients.rfm1718.show && clients.rfm1718.filtersArray &&clients.rfm1718.filtersArray.length > 0">
          <v-select v-model="selectedRfm1718" :options="clients.rfm1718.filtersArray" label="name"
            :closeOnSelect="false" :multiple="true" :clearSearchOnSelect="false" @input="updateSelectedRfm1718"
            ref='theSelectRfm1718'></v-select>
        </div>
        <div class="add-filter" @click="addFilter">{{$t('selectFilter.addFilter')}}</div>
      </div>
    </div>
  </div>
</template>

<script>

import Item from './Item'

export default {
  props: {
    show_filter: Boolean,
    businessUnit: String
  },
  data() {
    return {
      selectedFamilies: [],
      selectedCdGrpLevel2: [],
      selectedRfm2425: [],
      selectedRfm2324: [],
      selectedRfm2223: [],
      selectedRfm2122: [],
      selectedRfm2021: [],
      selectedRfm1920: [],
      selectedRfm1819: [],
      selectedRfm1718: [],
      selectedContactabilite: [],
      selectedBrands: [],
      selectedConstructeurs: [],
      selectedShopZone: [],
      selectedRecommendedFamilies: [],
      adherent: false,
      nonAdherent: false,
      pass_entretien: false,
      nopass_entretien: false,
      selectedValue: "",
      valueVisite:"",
      newFamilyCode:"",
      familyCodes: [],
      newProductCode:"",
      productCodes: [],
      shopCodes: [],
      newShopCode:"",
      tab: 'general',
      options: ["=", ">=", "<="],
      general: {
        cdGrpLevel1: {
          "name": "Catégorie (Niveau 1)",
          "value": false,
          "show": false,
          "operator": true,
          "filtersArray": [],
          "brand": ""
        },
        cdGrpLevel2: {
          "name": "Catégorie (Niveau 2)",
          "value": false,
          "show": false,
          "operator": true,
          "filtersArray": [],
          "brand": ""
        },
        cdFamily: {
          "name": "Famille",
          "value": false,
          "show": false,
          "operator": true,
          "filtersArray": [],
          "brand": ""
        },
        productBrand: {"name": "Marque", "value": false, "show": false,  "operator": true, "filtersArray": []},
        codeFamille: {
          name: "Code Famille",
          code : 'cdFamily',
          value: false,
          show: false,
          filtersArray: [],
          operator: true
        },
        cdProduct: {
          name: "Code Produit",
          value: false,
          show: false,
          filtersArray: [],
          operator: true
        }
      },
      clients: {
      recommendedFamilies: {
          name: "Familles recommandées",
          code : 'recos',
          value: false,
          show: false,
          filtersArray: [],
          operator: true
        },
        cdShop: {
          name: "Code Magasin",
          code: 'bills.cdShop',
          value: false,
          show: false,
          filtersArray: [],
          operator: true
        },
        constructeur: {
          name: "Constructeurs",
          value: false,
          show: false,
          operator: true,
          code: "bills.vehicles.brand",
          filtersArray: []
        },
        shopZone: {
          name: "Régions",
          code: "bills.shopZone",
          value: false,
          show: false,
          operator: true,
          filtersArray: []
        },
        rfm2425: {
          name: "RFM (24/25)",
          code: 'rfm_e2324',
          value: false,
          show: false,
          operator: false,
          filtersArray: [
          ]
        },
        rfm2324: {
          name: "RFM (23/24)",
          code: 'rfm_e2324',
          value: false,
          show: false,
          operator: false,
          filtersArray: [
          ]
        },
        rfm2223: {
          name: "RFM (22/23)",
          code: 'rfm_e2223',
          value: false,
          show: false,
          operator: false,
          filtersArray: [
          ]
        },
        rfm2122: {
          name: "RFM (21/21)",
          code: 'rfm_e2122',
          value: false,
          show: false,
          operator: false,
          filtersArray: [
          ]
        },
        rfm2021: {
          name: "RFM (20/21)",
          code: 'rfm_e2021',
          value: false,
          show: false,
          operator: false,
          filtersArray: [
          ]
        },
        rfm1920: {
          name: "RFM (19/20)",
          code: 'rfm_e1920',
          value: false,
          show: false,
          operator: false,
          filtersArray: [
          ]
        },
        rfm1819: {
          name: "RFM (18/19)",
          code: 'rfm_e1819',
          value: false,
          show: false,
          operator: false,
          filtersArray: [
          ]
        },
        rfm1718: {
          name: "RFM (17/18)",
          code: 'rfm_e1718',
          value: false,
          show: false,
          operator: false,
          filtersArray: []
        },
        contactabilite: {
          name: "Contactabilite",
          code: 'contactabilite',
          value: false,
          show: false,
          operator: false,
          filtersArray: []
        },
        civilite: {
          name: "Civilite",
          code: "civilite",
          value: false,
          show: false,
          operator: false,
          filters: {
            homme: {
              name: 'Homme',
              value: false,
              key: [1]
            },
            femme: {
              name: 'Femme',
              value: false,
              key: [2, 3]
            },
            societe: {
              name: 'Société',
              value: false,
              key: [4, 7, 8, 27, 9, 53, 75]
            },
            autre: {
              name: 'Autre',
              value: false,
              key: [0]
            },
          },
        },
        fidelite: {
          name: "Fidelite",
          value: false,
          show: false,
          filters: {
            adherent: {
              value: false,
              name: "Adhérent"
            },
            nonAdherent: {
              value: false,
              name: "Non-Adhérent"
            },
          }
        },
        pass_entretien: {
          name: "pass_entretien",
          value: false,
          show: false,
          filters: {
            pass_entretien: {
              value: false,
              name: "Avec"
            },
            nopass_entretien: {
              value: false,
              name: "Sans"
            },
          }
        },
        shopType: {
          name: "Type de magasin",
          value: false,
          show: false,
          selectedSuccursale: false,
          selectedFranchise: false,
          filters: {
            shopTypeValue: {
              value: false,
              name: "",
              code: null
            }
          }
        },
        visite: {
          name: "Visite",
          value: false,
          show: false,
          filters: {
            valueVisite: {
              value: '',
              name: "dtFirstPurchase",
              operator: ""
            }
          }
        },
        age: {
          name: "Age",
          value: false,
          show: false,
          filters: {
            valueAge: {
              value: '',
              name: "age",
              operator: ""
            }
          }
        }
      },
    }
  },
  components: {
    Item
  },
  computed: {
    computedVisite() {
      if(this.selectedValue && this.valueVisite) {
        // this.clients.visite.value = true
        // this.clients.visite.filters.valueVisite.value = true
      } else {
        // this.clients.visite.value = false
        // this.clients.visite.filters.valueVisite.value = false
      }
      return this.selectedValue +' '+ this.valueVisite
    }
  },
  methods: {
    shopTypeClick(shopType) {
      let shopeTypeObject = this.clients.shopType

      // Check if franchise filter is selected
      if(shopeTypeObject.selectedFranchise) {
        // Check if franchise AND succursale filters are selected
        // Set up data for the last one that have been selected and unselect the other
        if(shopeTypeObject.selectedSuccursale) {
          if(shopType === 'franchise') {
            shopeTypeObject.filters.shopTypeValue.code = 1
            shopeTypeObject.selectedSuccursale = false;
          }else if(shopType === 'succursale') {
            shopeTypeObject.filters.shopTypeValue.code = 2
            shopeTypeObject.selectedFranchise = false;
          }
          shopeTypeObject.filters.shopTypeValue.name = this.$t('selectFilter.'+shopType)
          shopeTypeObject.filters.shopTypeValue.value = true
        }
        // Set up data for the franchise filter
        shopeTypeObject.filters.shopTypeValue.value = true
        shopeTypeObject.filters.shopTypeValue.code = 1
        shopeTypeObject.filters.shopTypeValue.name = this.$t('selectFilter.franchise')
      }
      // Set up data for the succursale filter
      else if(shopeTypeObject.selectedSuccursale) {
        shopeTypeObject.filters.shopTypeValue.value = true
        shopeTypeObject.filters.shopTypeValue.code = 2
        shopeTypeObject.filters.shopTypeValue.name = this.$t('selectFilter.succursale')
      }
      // Nothing is selected, the value is set to false
      else {
        shopeTypeObject.filters.shopTypeValue.value = false
      }
    },

    updateSelectedFamilies(selectedFamilies){
      this.updateSelection(this.general.cdFamily, selectedFamilies)
    },

    updateSelectedCdGrpLevel2(selectedCdGrpLevel2){
      this.updateSelection(this.general.cdGrpLevel2, selectedCdGrpLevel2)
    },

    updateSelectedBrands(selectedBrands){
      this.updateSelection(this.general.productBrand, selectedBrands)
    },

    updateSelectedRfm2223(selectedRfm2425){
      this.updateSelection(this.clients.rfm2425, selectedRfm2425)
    },
    updateSelectedRfm2223(selectedRfm2324){
      this.updateSelection(this.clients.rfm2324, selectedRfm2324)
    },
    updateSelectedRfm2223(selectedRfm2223){
      this.updateSelection(this.clients.rfm2223, selectedRfm2223)
    },

    updateSelectedRfm2122(selectedRfm2122){
      this.updateSelection(this.clients.rfm2122, selectedRfm2122)
    },

    updateSelectedRfm2021(selectedRfm2021){
      this.updateSelection(this.clients.rfm2021, selectedRfm2021)
    },

    updateSelectedRfm1920(selectedRfm1920){
      this.updateSelection(this.clients.rfm1920, selectedRfm1920)
    },

    updateSelectedRfm1819(selectedRfm1819){
      this.updateSelection(this.clients.rfm1819, selectedRfm1819)
    },

    updateSelectedRfm1718(selectedRfm1718){
      this.updateSelection(this.clients.rfm1718, selectedRfm1718)
    },

    updateSelectedContactabilite(selectedContactabilite){
      this.updateSelection(this.clients.contactabilite, selectedContactabilite)
    },

    updateSelectedConstructeurs(selectedConstructeurs){
      this.updateSelection(this.clients.constructeur, selectedConstructeurs)
    },

    updateSelectedShopZone(selectedShopZone){
      this.updateSelection(this.clients.shopZone, selectedShopZone)
    },

    updateSelectedRecommendedFamilies(selectedRecommendedFamilies){
      this.updateSelection(this.clients.recommendedFamilies, selectedRecommendedFamilies)
    },

    updateSelection(obj, array) {
      obj.value = array.length != 0;
      obj.filtersArray.forEach(el => {
        el.value = array.indexOf(el) != -1;
      })
    },

    addFamilyCode() {
      if (this.businessUnit && this.businessUnit.startsWith('NOR')) {
        if (this.newFamilyCode.length < 3) {
          this.newFamilyCode = '000'.substring(0, 3 - this.newFamilyCode.length) + this.newFamilyCode
        }
      }
      this.familyCodes.push({name: this.newFamilyCode, key:this.newFamilyCode, value: true})
      this.newFamilyCode = ""
    },
    removeFamilyCode(code) {
      this.familyCodes.splice(code, 1)
    },
    addProductCode() {
      this.productCodes.push({name: this.newProductCode, key:this.newProductCode, value: true})
      this.newProductCode = ""
    },
    removeProductCode(code) {
      this.productCodes.splice(code, 1)
    },
    addShopCode() {
      this.shopCodes.push({name: this.newShopCode, key:this.newShopCode, value: true})
      this.newShopCode = ""
    },
    removeShopCode(code) {
      this.shopCodes.splice(code, 1)
    },
    resetValues: function (criterias, c) {
      criterias[c].show = criterias[c].value = false
      let arrays = criterias[c].filtersArray
      for (let i = 0; i < arrays.length; i++) {
        let item = arrays[i]
        item.value = false
      }
    },
    clean(criterias, clientCriterias) {
      let critNames = ['cdGrpLevel1', 'cdGrpLevel2', 'cdFamily', 'productBrand', 'codeFamille', "cdProduct"]
      critNames.forEach(c => {
        this.resetValues(criterias, c);
      })

      let clientCritNames = ['constructeur', 'shopZone', 'rfm1718', 'rfm1819', 'rfm1920', 'rfm2021', 'rfm2122', 'rfm2223', 'rfm2324', 'rfm2425', 'contactabilite', "cdShop"]
      clientCritNames.forEach(c => {
        this.resetValues(clientCriterias, c);
      })

      clientCriterias.fidelite.value = clientCriterias.fidelite.show = false
      clientCriterias.fidelite.filters.adherent.value = clientCriterias.fidelite.filters.nonAdherent.value = false
      clientCriterias.pass_entretien.filters.pass_entretien.value = clientCriterias.pass_entretien.filters.nopass_entretien.value = false
      clientCriterias.civilite.value = clientCriterias.civilite.show = false
      clientCriterias.civilite.filters.homme.value = clientCriterias.civilite.filters.femme.value = clientCriterias.civilite.filters.societe.value = clientCriterias.civilite.filters.autre.value = false
      clientCriterias.visite.filters.valueVisite.value = clientCriterias.age.filters.valueAge.value = ''
      clientCriterias.visite.filters.valueVisite.operator = clientCriterias.age.filters.valueAge.operator = ''
      clientCriterias.shopType.value = clientCriterias.shopType.show = clientCriterias.shopType.filters.shopTypeValue.value = false
      clientCriterias.shopType.selectedSuccursale = clientCriterias.shopType.selectedFranchise = false

      this.familyCodes = []
      this.selectedFamilies = []
      this.selectedCdGrpLevel2 = []
      this.productCodes = []
      this.shopCodes = []
      this.selectedContactabilite = []
      this.selectedRfm2425 = []
      this.selectedRfm2324 = []
      this.selectedRfm2223 = []
      this.selectedRfm2122 = []
      this.selectedRfm2021 = []
      this.selectedRfm1920 = []
      this.selectedRfm1819 = []
      this.selectedRfm1718 = []
      this.selectedBrands = []
      this.selectedConstructeurs = []
      this.selectedShopZone = []
      this.selectedRecommendedFamilies = []
      criterias.cdFamily.brand = ''
      criterias.cdGrpLevel1.brand = ''
      criterias.cdGrpLevel2.brand = ''

      if(this.$refs.theSelectFamilies) this.$refs.theSelectFamilies.onEscape()
      if(this.$refs.theSelectCdGrpLevel2) this.$refs.theSelectCdGrpLevel2.onEscape()
      if(this.$refs.theSelectRfm2425) this.$refs.theSelectRfm2425.onEscape()
      if(this.$refs.theSelectRfm2324) this.$refs.theSelectRfm2324.onEscape()
      if(this.$refs.theSelectRfm2223) this.$refs.theSelectRfm2223.onEscape()
      if(this.$refs.theSelectRfm2122) this.$refs.theSelectRfm2122.onEscape()
      if(this.$refs.theSelectRfm2021) this.$refs.theSelectRfm2021.onEscape()
      if(this.$refs.theSelectRfm1920) this.$refs.theSelectRfm1920.onEscape()
      if(this.$refs.theSelectRfm1819) this.$refs.theSelectRfm1819.onEscape()
      if(this.$refs.theSelectRfm1718) this.$refs.theSelectRfm1718.onEscape()
      if(this.$refs.theSelectBrands) this.$refs.theSelectBrands.onEscape()
      if(this.$refs.theSelectContactabilite) this.$refs.theSelectContactabilite.onEscape()
      if(this.$refs.theSelectConstructeur) this.$refs.theSelectConstructeur.onEscape()
      if(this.$refs.theSelectShopZone) this.$refs.theSelectShopZone.onEscape()
      if(this.$refs.theSelectedRecommendedFamilies) this.$refs.theSelectedRecommendedFamilies.onEscape()
    },

    clone(json) {
      return JSON.parse(JSON.stringify(json))
    },

    getFamilies(brand) {
      let families = require('../data/' + brand + 'Families.json')
      if (this.$store.state.user.families) {
        families.filtersArray = families.filtersArray.map(f => {
          if(this.$store.state.user.families.includes(f.key)) {
            return f
          }
          return null
        }).filter(f => f != null)
      }
      return families
    },

    getRecommendedFamilies(brand) {
      if (brand === 'nor')
        return require('../data/' + brand + 'RecommendedFamilies.json')
      else return {filtersArray: []}
    },

    getLevel1(brand) {
      return require('../data/' + brand + 'Level1.json')
    },

    getLevel2(brand) {
      return require('../data/' + brand + 'Level2.json')
    },

    getVehicles(brand) {
      return require('../data/' + brand + 'Vehicles.json')
    },

    getShopZone(shopZone) {
      // Le format de shopZones.json est un peu différend des autres, donc on doit
      // le parser pour récupérer les données sur la bonne région
      const allShopZone = this.clone(require('../data/shopZones.json'))

      let shopZoneFiltersArray = allShopZone.filtersArray.filter( element => element.shop_bu == shopZone )
      let correctlyFormattedFiltersArray = []
      if (shopZoneFiltersArray.length > 0) {
        correctlyFormattedFiltersArray = shopZoneFiltersArray[0].zones
      }
      let shopZones = allShopZone
      shopZones.filtersArray = correctlyFormattedFiltersArray

      return shopZones
    },

    getBrands(brand) {
      let brands = require('../data/' + brand + 'Brands.json')
      if (this.$store.state.user.brands) {
        brands.filtersArray = brands.filtersArray.map(b => {
          if(this.$store.state.user.brands.includes(b.key)) {
            return b
          }
          return null
        }).filter(b => b != null)
      }
      return brands
    },

    getContactabilite() {
        return require('../data/contactabilite.json')
    },

    getRfm(bu, name="RFM (22/23)", code = "rfm_e2223") {
      let toReturn = {}
      toReturn = bu === 'MIDFRA' ? require('../data/midfraRfm.json') : require('../data/rfm.json');
      toReturn.name = name
      toReturn.code = code
      return this.clone(toReturn)
    },

    setSelectedValue ( criterias ) {
      for (let g in criterias) {
        let exist= false
        for (let f in criterias[g].filtersArray) {
          if (criterias[g].filtersArray[f].value) {
            criterias[g].value = exist = true
          }
        }
        criterias[g].value = exist
      }
    },

    addFilter () {
      this.setSelectedValue(this.general)
      this.setSelectedValue(this.clients)

      for (let h in this.clients) {
        for (let i in this.clients[h].filters) {
          if (this.clients[h].filters[i].value) this.clients[h].value = true
        }
      }
      this.clients.visite.filters.valueVisite.name = this.computedVisite
      if (this.familyCodes.length > 0) {
        this.general.codeFamille.value = true
        this.general.codeFamille.filtersArray = this.familyCodes
      }

      if (this.productCodes.length > 0) {
        this.general.cdProduct.value = true
        this.general.cdProduct.filtersArray = this.productCodes
      }

      if (this.shopCodes.length > 0) {
        this.clients.cdShop.value = true
        this.clients.cdShop.filtersArray = this.shopCodes
      }

      this.general.cdFamily.familyBrand = this.familyBrand
      
      let generalClone = this.clone(this.general)
      let clientsClone = this.clone(this.clients)

      this.clean(this.general, this.clients)
      this.$emit('createFilter', generalClone, clientsClone)
    }

  },

  watch : {
    show_filter:function(val) {
      if(val == false) {
        this.selectedValue = ""
        this.valueVisite = ""
      }
    },
    businessUnit: function(val, oldVal) {
      console.log("Set business unit=" + val)
      let newPrefix = val.substring(0, 3)
      let oldPrefix = oldVal.substring(0, 3)
      let brand = newPrefix.toLowerCase()
      this.clients.contactabilite = this.getContactabilite()
      if (val != oldVal) {
        // change of bu
        this.clients.rfm2425 = this.getRfm(val)
        this.clients.rfm2324 = this.getRfm(val, "RFM (23/24)", "rfm_e2324")
        this.clients.rfm2223 = this.getRfm(val, "RFM (22/23)", "rfm_e2223")
        this.clients.rfm2122 = this.getRfm(val, "RFM (21/22)", "rfm_e2122")
        this.clients.rfm2021 = this.getRfm(val, "RFM (20/21)", "rfm_e2021")
        this.clients.rfm1920 = this.getRfm(val, "RFM (19/20)", "rfm_e1920")
        this.clients.rfm1819 = this.getRfm(val, "RFM (18/19)", "rfm_e1819")
        this.clients.rfm1718 = this.getRfm(val, "RFM (17/18)", "rfm_e1718")
        this.clients.shopZone = this.getShopZone(val)
      }
      if (newPrefix !== oldPrefix) {
        //change of brand
        this.clients.recommendedFamilies = this.getRecommendedFamilies(brand)
        this.general.cdFamily = this.getFamilies(brand)
        this.general.cdGrpLevel1 = this.getLevel1(brand)
        this.general.productBrand = this.getBrands(brand)
        this.general.cdGrpLevel2 = this.getLevel2(brand)
        this.clients.constructeur = this.getVehicles(brand)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/components/select_filter.sass"
</style>
